import { QueueAuditLogEntry } from '../types/auditLogs.types';
import { EnrichmentMaps } from '../types/enrichment.types';
import { EnrichedQueueAuditLogEntry } from '../types/resources/queuesAuditLogs.types';

/**
 * Resolves the agent and team ids referenced by a queue audit-log entry to their
 * human-readable names using the enrichment maps.
 */
export function enrichQueueAuditLogEntry(
  entry: QueueAuditLogEntry,
  { users, teams }: EnrichmentMaps,
): EnrichedQueueAuditLogEntry {
  if ('agent_id' in entry && entry.agent_id) {
    return { ...entry, agent_name: users[entry.agent_id]?.name };
  }

  if ('team_id' in entry && entry.team_id) {
    return { ...entry, team_name: teams[entry.team_id]?.name };
  }

  return entry;
}
